import { render, staticRenderFns } from "./AlklimaDashboard.vue?vue&type=template&id=5b445b31&"
import script from "./AlklimaDashboard.vue?vue&type=script&lang=js&"
export * from "./AlklimaDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports